import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconCornerRadius: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="corner-radius, border-radius"><path d="M21 3.75H3.75V21" stroke="currentColor" strokeWidth="1.5"/></CentralIconBase>;
};

export default IconCornerRadius;
